import React, { useMemo } from 'react';
import { getEnvConfig } from '../../config/config';
import { Link } from 'react-router-dom';
import styles from './playerCard.module.scss';
import { Wtn } from '@clubspark-react/ui';
import { getConfigColorForAdornmentMark } from '../utilities/utilities';
import { WTNPayload } from '../../graphql-types/wtn';

interface PlayerCardProps {
  data?: {
    standardGivenName?: string;
    standardFamilyName?: string;
    class?: string;
    avatarUrl?: string;
    personId?: string;
    tennisId: string | null;
  };
  wtnData: any;
}

const PlayerCard: React.FC<PlayerCardProps> = ({ data, wtnData }) => {
  // const playerWTNData = wtnData.persons wtnData.find(({tennisId}) => tennisId === data?.tennisId);
  const env = getEnvConfig();

  const avatarImg = () => {
    return (
      <div className={styles.playerAvatar}>
        <img src={data?.avatarUrl} alt="player avatar" />
      </div>
    );
  };

  const wtn = wtnData;

  const avatarName = () => {
    return (
      <div className={styles.playerAvatar}>
        <p>
          {data?.standardGivenName !== null ? data?.standardGivenName?.substring(0, 1) : ''}
          {data?.standardFamilyName !== null ? data?.standardFamilyName?.substring(0, 1) : ''}
        </p>
      </div>
    );
  };

  const wtnSinglesData: WTNPayload = useMemo(
    () => wtn?.find((wtnData: WTNPayload) => wtnData.type === 'SINGLE'),
    [wtn]
  );

  return (
    <div className={styles.playerCard}>
      <div className={styles.playerName}>
        {data?.avatarUrl === null ? avatarName() : avatarImg()}
        <h3>
          <Link to={`${env.root}/Player/${data?.personId}`}>
            <span>{data?.standardGivenName}</span> <strong>{data?.standardFamilyName}</strong>
          </Link>
        </h3>
      </div>
      {!!wtnSinglesData && (
        <div className={styles.wtnMobileView}>
          {!wtnSinglesData.isRanked ? (
            <Wtn
              className={styles.wtnStyles}
              props={{
                mark: {
                  fill: getConfigColorForAdornmentMark(wtnSinglesData)
                }
              }}
              confident={false}
            >
              {wtnSinglesData?.tennisNumber ?? 0}
            </Wtn>
          ) : (
            <span className={styles.wtnProZoneLabel}>Pro Zone</span>
          )}
        </div>
      )}
      {!!wtnSinglesData ? (
        <div className={styles.playerDetails}>
          <dl>
            <dt>
              <abbr title="World Tennis Number">WTN</abbr>
            </dt>
            <dd>
              {!wtnSinglesData?.isRanked ? (
                <Wtn
                  className={styles.wtnStyles}
                  props={{
                    mark: {
                      fill: getConfigColorForAdornmentMark(wtnSinglesData)
                    }
                  }}
                  confident={false}
                >
                  {wtnSinglesData?.tennisNumber ?? 0}
                </Wtn>
              ) : (
                'Pro Zone'
              )}
            </dd>
          </dl>
        </div>
      ) : (
        <div className={styles.playerDetails}>
          <dl>
            <dt>
              <abbr title="World Tennis Number">WTN</abbr>
            </dt>
            <dd>
              <Wtn hideMark className={styles.wtnStyles}>
                {0}
              </Wtn>
            </dd>
          </dl>
        </div>
      )}

      {data?.class && (
        <div className={styles.playerDetails}>
          <dl>
            <dt>Class</dt>
            <dd>{data?.class}</dd>
          </dl>
        </div>
      )}
    </div>
  );
};

export default PlayerCard;
